import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getPriceGap=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_PRICE_GAP_START
    })
    const options={
        url:`${api}/priceGaps`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_PRICE_GAP_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_PRICE_GAP_FAIL,
                payload:getMessage(error)
            }))
}